<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<!-- 个人中心导航 -->
				<Usernavleft></Usernavleft>
				<div class="ttshop_useright">
					<div class="ttshop_userights">
						<div class="ttshop_myorder clearfloat">
							<ul class="clearfloat">
								<li @click="orderTab(-1)" :class="{active:currTab ==-1}">全部订单</li>
								<li @click="orderTab(0)" :class="{active:currTab ==0}">待付款</li>
								<li @click="orderTab(1)" :class="{active:currTab ==1}">待发货</li>
								<li @click="orderTab(2)" :class="{active:currTab ==2}">待收货</li>
								<li @click="orderTab(3)" :class="{active:currTab ==3}">已完成</li>
								<li @click="orderTab(4)" :class="{active:currTab ==4}">退款/售后</li>
							</ul>
							<div class="ttshop_myorderseach" style="display:none;">
								<input type="text" placeholder="请输入您的订单号">
								<button>搜索订单</button>
							</div>
						</div>
						<!-- 暂无订单展示 -->
						<div v-show="list.length == 0">
							<div class="ttshop_myorderzw" v-show="finish">
								<img src="../../assets/images/ttshop_zanwu.png" alt="">
								<p>暂无订单</p>
							</div>
						</div>

						<!-- 订单列表 -->
						<div class="ttshop_myorderlist" v-show="list.length > 0">
							<div class="ttshop_myordertitle clearfloat">
								<div style="float:left;width:76%;" class="clearfloat">
									<div class="ttshop_myordertext">
										<div class="ttshop_myordertexter clearfloat">
											<p>商品信息</p>
											<!-- <el-dropdown>
                      <p>商品信息</p>
                      <i><img src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>昨天</el-dropdown-item>
                        <el-dropdown-item>近一周</el-dropdown-item>
                        <el-dropdown-item>近一个月</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown> -->
										</div>
									</div>
									<div class="ttshop_myorderdj">
										<p>单价</p>
									</div>
									<div class="ttshop_myorderdj">
										<p>数量</p>
									</div>
									<div class="ttshop_myorderdjs">
										<p>收货人</p>
									</div>
									<div class="ttshop_myorderzfje">
										<p>支付总金额</p>
									</div>
								</div>

								<!-- <div class="ttshop_myorderzt">
                  <div class="ttshop_myorderzts d-flex justify-content-center clearfloat">
                    <p>全部状态</p>
                    <el-dropdown>
                      <p>全部状态</p>
                      <i><img src="../../assets/images/ttshop_orderxl.png" alt=""></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>已发货</el-dropdown-item>
                        <el-dropdown-item>待发货</el-dropdown-item>
                        <el-dropdown-item>已付款</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div> -->
								<div class="ttshop_myordercz">
									<p>操作</p>
								</div>
							</div>
							<div class="ttshop_myordercon" v-for="(item,index) in list" :key="index">
								<div class="ttshop_myorderconed clearfloat">
									<div class="ttshop_myordercontitle clearfloat">
										<p>{{item.addtime}}</p>
										<p>订单号：<span>{{item.order_no}}</span></p>
										<p>卖家：<strong>{{item.mch.name}}</strong></p>
										<div class="ttshop_myordercontitle_right">
											<template v-if="currTab == -1">
												<p class="ttshop_over" v-if="item.is_pay == 1 && item.is_send == 0 && item.apply_delete==1 && item.is_revoke == 1">退款成功</p>
												<p class="ttshop_over" v-else-if="item.is_revoke == 1">已取消</p>
												<template v-else-if="item.is_pay == 0">
													<template v-if="item.pay_type == 2">
														<p class="ttshop_over" v-if="item.is_send == 0 && item.is_revoke == 0">待发货</p>
														<p class="ttshop_over" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
														<p class="ttshop_over" v-if="item.is_comment == 0 && item.is_confirm == 1">待评价</p>
														<p class="ttshop_over" v-else-if="item.is_confirm == 1">已收货</p>
													</template>
													<p class="ttshop_over" v-else>待付款</p>
												</template>
												<p class="ttshop_over" v-if="item.is_send == 0 && item.is_pay == 1 && item.is_revoke == 0">待发货</p>
												<p class="ttshop_over" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
												<p class="ttshop_over" v-if="item.is_comment == 0 && item.is_confirm == 1">待评价</p>
												<p class="ttshop_over" v-else-if="item.is_confirm == 1">已收货</p>
											</template>
											<template v-if="currTab == 4">
												<p class="ttshop_over" v-if="item.refund_type==1">退货退款：￥{{item.refund_price}}</p>
												<p class="ttshop_over" v-if="item.refund_type==2">换货</p>
											</template>
										</div>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop_myorderconlist clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
												<div class="ttshop_myorderconleft clearfloat">
													<div class="ttshop_orderimg">
														<img :src="items.goods_pic" alt="">
													</div>
													<div class="ttshop_ordertext">
														<h5>{{items.goods_name}}</h5>
														<span v-for="(attr,ids) in items.attr_list" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
														<!-- <span>尺码：<strong>170/M</strong></span> -->
														<!-- <div>123</div> -->
													</div>

												</div>
												<div class="ttshop_myorderdj">
													<p>￥<span>{{items.price}}</span></p>
												</div>
												<div class="ttshop_myorderdj ttshop_myorderdjer">
													<p><span>{{items.num}}</span></p>
												</div>
												<div class="ttshop_shr">
													<p>{{item.consignee}}</p>
												</div>
												<div class="ttshop_zfzje">
													<p>￥<span>{{item.pay_price}}</span></p>
													<!-- <strong>发票信息</strong> -->
												</div>
											</div>
											<!-- <div class="ttshop_caozuo" style="display:none">
                        <p class="ttshop_ljzf" v-show="item.is_pay == 0 && item.pay_type != 2 && item.is_revoke == 0" @click="payOrder(item.order_id,item.total_price)">立即支付</p>
                        <p class="ttshop_ljzf" v-show="item.is_pay && item.is_send==0">退款</p>
                        <p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 1 && item.is_comment == 0">评价</p>
                        <p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 0">确认收货</p>
                        && store.store.is_comment == 1 是否开启评价
                        <p class="ttshop_cztext">修改订单</p>
                        <p class="ttshop_cztext" v-show="!item.is_pay && item.is_revoke == 0 && item.pay_type != 2" @click="orderRevoke(item.order_id)">取消订单</p>
                        <p class="ttshop_cztext" @click="goOrderxq(item)">订单详情</p>
                      </div> -->
										</div>
										<div class="ttshop_caozuos d-flex  align-items-center justify-content-center">
											<div v-if="currTab == 4">
												<!-- <view wx:if="{{item.refund_type==1}}">
                          <block wx:if="{{item.refund_status==0}}">
                            <text wx:if="{{item.is_agree==0}}">等待审核中</text>
                            <text wx:else>
                              <block wx:if="{{item.is_user_send==0}}">已同意退货，请及时发货</block>
                              <block wx:else>已发货，待平台确认</block>
                            </text>
                          </block>
                          <text wx:if="{{item.refund_status==1}}" style="color: #36ba75">已同意退货并已退款</text>
                          <text wx:if="{{item.refund_status==3}}" style="color: #ff4544">已拒绝退货</text>
                        </view>
                        <view wx:if="{{item.refund_type==2}}">
                          <block wx:if="{{item.refund_status==0}}">
                            <text wx:if="{{item.is_agree==0}}">等待审核中</text>
                            <text wx:else>
                              <block wx:if="{{item.is_user_send==0}}">已同意换货，请及时发货</block>
                              <block wx:else>已发货，待平台确认</block>
                            </text>
                          </block>
                          <text wx:if="{{item.refund_status==1}}" style="color: #36ba75">已同意换货</text>
                          <text wx:if="{{item.refund_status==2}}" style="color: #36ba75">卖家已发货</text>
                          <text wx:if="{{item.refund_status==3}}" style="color: #ff4544">已拒绝换货</text>
                        </view>
                        <view data-order-refund-id="{{item.order_refund_id}}" wx:if="{{item.refund_status==0 && item.is_agree==0}}" bindtap="withdraw" class="ctrlBtn">撤回申请</view> -->
												<p class="ttshop_cztext" @click="goOrderxq(item)">订单详情</p>
												<p class="ttshop_ljzf" v-if="item.refund_status==0 && item.is_agree==0" @click="withdraw(item.order_refund_id)">撤回申请</p>
												<template v-if="item.refund_type==1">
													<template v-if="item.refund_status==0">
														<p class="ttshop_cztexts" v-if="item.is_agree==0">等待审核中</p>
														<template v-else>
															<p class="ttshop_cztexts" v-if="item.is_user_send==0">已同意退货，请及时发货</p>
															<p class="ttshop_cztexts" v-else>已发货，待平台确认</p>
														</template>
													</template>
													<p class="ttshop_cztexts" v-if="item.refund_status==1">已同意退货并已退款</p>
													<p class="ttshop_cztexts" v-if="item.refund_status==3">已拒绝退货</p>
												</template>
												<template v-if="item.refund_type==2">
													<template v-if="item.refund_status==0">
														<p class="ttshop_cztexts" v-if="item.is_agree==0">等待审核中</p>
														<template v-else>
															<p class="ttshop_cztexts" v-if="item.is_user_send==0">已同意退货，请及时发货</p>
															<p class="ttshop_cztexts" v-else>已发货，待平台确认</p>
														</template>
													</template>
													<p class="ttshop_cztexts" v-if="item.refund_status==1">已同意换货</p>
													<p class="ttshop_cztexts" v-if="item.refund_status==2">卖家已发货</p>
													<p class="ttshop_cztexts" v-if="item.refund_status==3">已拒绝退货</p>
												</template>
											</div>
											<div v-else>
												<p class="ttshop_ljzf" v-show="item.is_pay == 0 && item.pay_type != 2 && item.is_revoke == 0" @click="openPayType(index)">立即支付</p>
												<p class="ttshop_ljzf" v-show="item.is_pay && item.is_send==0 &&item.apply_delete!=1" @click="orderRevoke(item.order_id)">退款</p>
												<p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 1 && item.is_comment == 0" @click="goEvaluate(item.order_id)">评价</p>
												<p class="ttshop_ljzf" v-show="item.is_send == 1 && item.is_confirm == 0" @click="confirm(item.order_id)">确认收货</p>
												<div class="ttshop_cztexts" v-show="item.is_send==0&&item.apply_delete==1 && item.is_revoke == 0">退款申请中</div>
												<p class="ttshop_cztexts" v-show="item.is_send==0 &&item.apply_delete==1 && item.is_revoke == 1">退款成功</p>
												<!-- && store.store.is_comment == 1 是否开启评价 -->
												<!-- <p class="ttshop_cztext">修改订单</p> -->
												<p class="ttshop_cztext" v-show="!item.is_pay && item.is_revoke == 0 && item.pay_type != 2" @click="orderRevoke(item.order_id)">取消订单</p>
												<p class="ttshop_cztext" @click="goOrderxq(item)">订单详情</p>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="ttshop_myorderpage clearfloat" v-show="pageShow">
								<el-pagination class="ttshop_pages" @current-change="handleCurrentChange" :current-page.sync="page" background
								 layout="prev, pager, next" @prev-click="pages_perv" @next-click="page_next" :page-count="page_count"></el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ttshop_pay">
			<el-dialog title="" :visible.sync="shopVisible" :before-close="payContTypeChange">
				<div class="pay-title d-flex align-items-center justify-content-center">微信支付￥{{payNum}}</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center ">
					<div id="qrcode" ref="qrcode"></div>
				</div>
			</el-dialog>
		</div>
		<Foot></Foot>
		<!-- 支付方式 -->
		<div class="ttshop_agreement" v-show="check_pay_type">
			<div class="ttshop_agreementbj" @click="closePayType"></div>
			<div class="ttshop_agreementbox">
				<div class="ttshop_agreementitle clearfloat">
					<h5>支付方式</h5>
					<div class="close" @click="closePayType"></div>
				</div>
				<div class="ttshop_agreementext">
					<div class="pay-item clearfloat" v-for="(payitem, payindex) in pay_type_list" :key="payindex" :data-index="payindex" v-show="payitem.payment == 0 || payitem.payment == 1" @click="checkPayType" :class="{active:payitem.payment == payment_type}">
						<div class="pay-img">
							<img :src="payitem.icon" alt />
						</div>
						<div class="pay-name">{{payitem.name}}</div>
						<div class="pay-select" v-show="payitem.payment == payment_type">
							<img src="../../assets/images/brand.png" alt />
						</div>
					</div>
				</div>
				<div class="ttshop_agreementbut">
					<button @click="payOrder()">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Usernavleft from "./components/user_navleft";
	import QRCode from "qrcodejs2";
	let Base64 = require("js-base64").Base64;
	import "./user.css";
	export default {
		components: {
			Header,
			Userheader,
			Usernavleft,
			Foot,
		},
		data() {
			return {
				list: "",
				shopVisible: false,
				payNum: "",
				currTab: -1,
				time: "",
				page_count: 0,
				page: 1,
				finish: false,
				pageShow: true,
				pay_type_list: [],
				payment_type: -1,
				check_pay_type: false,//支付方式
				order_index: -1,//选中的订单
			};
		},
		mounted() {
			if (this.$route.query.tab) {
				this.currTab = this.$route.query.tab;
			}
			console.log(this.currTab, this.$route.query.tab);

			this.getorderList();
		},
		methods: {
			// 选择支付方式
			checkPayType(e){
				let that = this;
				let index = e.currentTarget.dataset.index;
				that.payment_type = that.pay_type_list[index].payment;
			},
			openPayType(index){
				this.check_pay_type = true;
				this.order_index = index;
			},
			closePayType(){
				this.check_pay_type = false;
			},
			//切换
			orderTab(index) {
				// if (index > 1) {
				//   this.currTab = index;
				//   this.list = [];
				//   this.finish = true;
				// } else {
				//   if (this.currTab != index) {
				//     this.currTab = index;
				//     this.page = 1;
				//     this.getorderList();
				//   }
				// }
				if (this.currTab != index) {
					this.currTab = index;
					this.page = 1;
					this.getorderList();
				}
			},
			//获取订单列表
			getorderList() {
				this.finish = false;
				this.$api
					.orderList({
						status: this.currTab,
						limit: 5,
						page: this.page,
					})
					.then((res) => {
						console.log(res.data);
						this.list = res.data.list;
						this.page_count = res.data.page_count;
						this.finish = true;
						this.pay_type_list = res.data.pay_type_list;
						if(res.data.pay_type_list[0].payment == 0 || res.data.pay_type_list[0].payment == 1){
							this.payment_type = res.data.pay_type_list[0].payment;
						}
						if (res.data.page_count == 1) {
							this.pageShow = false;
						} else {
							this.pageShow = true;
						}
					})
					.catch((err) => {
						console.log(err);
						// this.user = err;
					});
			},
			// 支付二维码关闭
			payContTypeChange() {
				let that = this;
				that
					.$confirm("是否取消支付", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						that.shopVisible = false;
						clearInterval(this.time);
						this.getorderList();
					})
					.catch(() => {
						console.log("取消");
					});
			},
			//订单详情
			goOrderxq(item) {
				console.log(item);
				if (Number(item.refund_type) == 1 || Number(item.refund_type) == 2) {
					this.$router.push({
						path: "/ttshop_barteragree",
						query: {
							id: item.order_refund_id
						},
					});
				} else {
					this.$router.push({
						path: "/ttshop_orderxq",
						query: {
							id: item.order_id
						},
					});
				}
			},
			//订单详情
			goEvaluate(id) {
				this.$router.push({
					path: "/ttshop_evaluate",
					query: {
						id: id
					}
				});
			},
			//取消订单
			orderRevoke(id) {
				this.$confirm("确定取消订单？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$api
							.orderRevoke({
								order_id: id,
							})
							.then((res) => {
								this.$message({
									type: "success",
									message: res.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
								this.getorderList();
							})
							.catch((err) => {
								// console.log(err);
								this.$message({
									type: "success",
									message: err.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
							});
					})
					.catch(() => {
						// this.$message({
						//   type: "info",
						//   message: "已取消删除",
						// });
					});
			},
			//确认收货
			confirm(id) {
				this.$confirm("是否确认已收到货物？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$api
							.confirm({
								order_id: id,
							})
							.then((res) => {
								this.$message({
									type: "success",
									message: res.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
								this.getorderList();
							})
							.catch((err) => {
								// console.log(err);
								this.$message({
									type: "success",
									message: err.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
							});
					})
					.catch(() => {
						// this.$message({
						//   type: "info",
						//   message: "已取消删除",
						// });
					});
			},
			//支付
			payOrder() {
				let _this = this;
				let id = _this.list[_this.order_index].order_id;
				let payNum = _this.list[_this.order_index].total_price;
				this.payNum = payNum;
				let params = {order_id: id};
				_this.check_pay_type = false;
				if(_this.payment_type == 0){//支付宝
					let payurl = window.location.href;
					let payurls = payurl.split("#")[0] + '#/ttshop_usermyorder';
					params.pay_type = "ALIPAY";
					params.return_url = payurls;
				}else if(_this.payment_type == 1){//微信
					params.pay_type = "WECHAT_PAY"
				}
				_this.$api.orderPay(params).then((res) => {
					if(_this.payment_type == 0){
						window.sessionStorage.setItem('alipay_type',true);
						const div = document.createElement('div');
						div.innerHTML = res.data;
						document.body.appendChild(div);
						document.forms[0].submit();
					}else if(_this.payment_type == 1){
						_this.shopVisible = true;
						_this.time = setInterval(() => {
							_this.orderStatus(res.res.order_no);
						}, 5000);
						let url = Base64.decode(res.res.code_url);
						setTimeout(function() {
							_this.qrcodeScan(url);
						}, 100);
					}
				})
				.catch((err) => {
					
				});
			},
			qrcodeScan(url) {
				this.$refs.qrcode.innerHTML = "";
				//生成二维码
				let qrcode = new QRCode("qrcode", {
					width: 150, // 二维码宽度
					height: 150, // 二维码高度
					text: url,
				});
			},
			//订单状态
			orderStatus(order) {
				if (this.shopVisible == false) {
					clearInterval(this.time);
					console.log("123");
				}
				this.$api
					.orderStatus({
						order_no: "order_" + order,
					})
					.then((res) => {
						if (res.code == 0) {
							clearInterval(this.time);
							this.$message({
								type: "success",
								message: res.msg,
								showClose: true,
								offset: 200,
								duration: 1000,
							});
							this.shopVisible = false;
							this.getorderList();
							// this.$router.push("/ttshop_mybalance");
						}
					})
					.catch((err) => {});
			},
			//上一页
			pages_perv() {
				this.page--;
				this.common.backTop();
				this.getorderList();
			},
			// 下一页
			page_next() {
				this.page++;
				this.common.backTop();
				this.getorderList();
			},
			// 输入分页
			handleCurrentChange(e) {
				this.page = e;
				this.common.backTop();
				this.getorderList();
			},
			//撤回申请
			withdraw(id) {
				this.$confirm("是否撤回申请？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$api
							.revokeRefund({
								order_type: "SHOP",
								order_refund_id: id,
							})
							.then((res) => {
								this.$message({
									type: "success",
									message: res.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
								this.getorderList();
							})
							.catch((err) => {
								// console.log(err);
								this.$message({
									type: "success",
									message: err.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
							});
					})
					.catch(() => {
						// this.$message({
						//   type: "info",
						//   message: "已取消删除",
						// });
					});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.pay-item{
		position: relative;
		width: 80%;
		background: #ffffff;
		border-radius: 2px;
		border: 1px solid #ebebeb;
		cursor: pointer;
		padding: 7px;
		box-sizing: border-box;
		margin: 0 auto 20px;
		&.active{
			border-color: #ff0e25;
		}
		.pay-img{
			float: left;
			width: 28px;
			height: 28px;
			border-radius: 2px;
			overflow: hidden;
		}
		.pay-name{
			float: left;
			padding-left: 12px;
			font-size: 14px;
			color: #333;
			line-height: 28px;
		}
		.pay-select{
			width: 12px;
			height: 12px;
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
	// 支付方式
	.ttshop_agreement {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;
	
		.ttshop_agreementbj {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
		}
	
		.ttshop_agreementbox {
			width: 400px;
			height: 260px;
			background: #fff;
			position: fixed;
			top: 50%;
			left: 50%;
			margin-left: -200px;
			margin-top: -130px;
			border: 4px solid rgba(0, 0, 0, 0.4);
			border-radius: 4px;
	
			.ttshop_agreementitle {
				width: 100%;
				height: 40px;
				line-height: 40px;
				background: #f5f5f5;
				padding: 0 15px;
				box-sizing: border-box;
	
				h5 {
					float: left;
					font-size: 14px;
					color: #333;
					font-weight: bold;
				}
	
				.close {
					cursor: pointer;
					float: right;
					display: block;
					width: 20px;
					height: 20px;
					background: url(../../assets/images/ttshop_colse.png) center no-repeat;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					outline: none;
					margin-top: 10px;
	
					&:hover {
						background: url(../../assets/images/ttshop_colsed.png) center no-repeat;
					}
				}
			}
	
			.ttshop_agreementext {
				width: 100%;
				padding: 20px 20px 10px 20px;
				box-sizing: border-box;
	
				p {
					font-size: 14px;
					color: #333;
					text-indent: 2em;
					line-height: 26px;
				}
			}
	
			.ttshop_agreementbut {
				width: 100%;
				height: 60px;
				position: absolute;
				bottom: 0;
				left: 0;
				box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
	
				button {
					display: block;
					width: 180px;
					height: 40px;
					font-size: 14px;
					color: #fff;
					border-radius: 2px;
					outline: none;
					margin: 10px auto 0;
					border: 0;
					cursor: pointer;
					background: #ff0e25;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
	
					&:hover {
						box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
					}
				}
			}
		}
	}
	.orderlist {
		width: 100%;
		box-sizing: border-box;

		.listitem {
			float: left;
			width: 76%;
		}
	}

	.ttshop_userights {
		padding: 16px 24px;
		box-sizing: border-box;
		background: #fff;

		.ttshop_myorder {
			width: 100%;
			margin-bottom: 16px;

			ul {
				float: left;

				li {
					float: left;
					font-size: 12px;
					color: #333;
					font-weight: 400;
					line-height: 12px;
					padding: 8px 0;
					box-sizing: border-box;
					margin-right: 24px;
					cursor: pointer;
					position: relative;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&::before {
						content: "";
						width: 0%;
						height: 2px;
						background: #ff0e25;
						position: absolute;
						bottom: -2px;
						left: 50%;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;
						transform: translateX(-50%);
						-moz-transform: translateX(-50%);
						-webkit-transform: translateX(-50%);
						-o-transform: translateX(-50%);
					}

					&:hover {
						color: #ff0e25;
					}

					&:hover::before {
						width: 100%;
					}

					&.active {
						font-weight: 600;
						color: #ff0e25;
					}

					&.active:before {
						width: 100%;
					}
				}

				& li:last-child {
					margin-right: 0;
				}
			}

			.ttshop_myorderseach {
				float: right;
				position: relative;

				input {
					width: 211px;
					height: 28px;
					border: 1px solid #ebebeb;
					font-size: 12px;
					color: #333;
					padding: 0 70px 0 8px;
					box-sizing: border-box;
					outline: none;
					border-radius: 2px;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&:focus {
						border-color: #ff0e25;
					}
				}

				button {
					width: 62px;
					height: 26px;
					display: block;
					font-size: 12px;
					color: #333;
					text-align: center;
					position: absolute;
					top: 1px;
					right: 1px;
					border: 0;
					outline: none;
					background: #ebebeb;
					cursor: pointer;
					border-radius: 0 2px 2px 0;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;

					&:hover {
						background: #ff0e25;
						color: #fff;
					}
				}
			}
		}

		.ttshop_myorderzw {
			width: 100%;
			min-height: 600px;
			background: #fff;
			padding-top: 180px;
			box-sizing: border-box;

			// display: none;
			img {
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 14px;
				color: #333;
				text-align: center;
			}
		}

		.ttshop_myorderlist {
			width: 100%;

			.ttshop_myordertitle {
				width: 100%;
				background: #f5f5f5;
				height: 32px;
				margin-bottom: 20px;

				.ttshop_myordertext {
					float: left;
					width: 50%;
					padding-top: 8px;
					padding-left: 20px;
					box-sizing: border-box;

					.ttshop_myordertexter {
						display: table;
						// cursor: pointer;
						position: relative;

						p {
							float: left;
							font-size: 12px;
							color: #333;
						}

						i {
							float: left;
							width: 12px;
							height: 12px;
							margin-top: 2px;

							img {
								display: block;
								width: 100%;
							}
						}
					}
				}

				.ttshop_myorderdj {
					float: left;
					width: 11%;
					padding-top: 8px;
					box-sizing: border-box;

					p {
						font-size: 12px;
						color: #333;
						text-align: center;
					}
				}

				.ttshop_myorderdjs {
					float: left;
					width: 12%;
					padding-top: 8px;
					box-sizing: border-box;

					p {
						font-size: 12px;
						color: #333;
						text-align: center;
					}
				}

				.ttshop_myorderzfje {
					float: left;
					width: 16%;
					padding-top: 8px;
					box-sizing: border-box;

					p {
						font-size: 12px;
						color: #333;
						text-align: center;
					}
				}

				// .ttshop_myorderzt {
				//   float: left;
				//   width: 14%;
				//   padding-top: 8px;
				//   box-sizing: border-box;
				//   .ttshop_myorderzts {
				//     // cursor: pointer;
				//     p {
				//       float: left;
				//       font-size: 12px;
				//       color: #333;
				//     }
				//     i {
				//       float: left;
				//       width: 12px;
				//       height: 12px;
				//       margin-top: 2px;
				//       img {
				//         display: block;
				//         width: 100%;
				//       }
				//     }
				//   }
				// }
				.ttshop_myordercz {
					float: left;
					width: 24%;
					padding-top: 8px;
					box-sizing: border-box;

					p {
						font-size: 12px;
						color: #333;
						text-align: center;
					}
				}
			}

			.ttshop_myordercon {
				width: 100%;

				.ttshop_myorderconed {
					width: 100%;
					margin-bottom: 20px;

					.ttshop_myordercontitle {
						width: 100%;
						height: 32px;
						background: #f5f5f5;
						padding: 0 20px;
						box-sizing: border-box;
						line-height: 32px;

						p {
							float: left;
							font-size: 12px;
							color: #999;
							margin-right: 24px;

							span {
								font-size: 12px;
								color: #999;
							}

							strong {
								color: #333;
								font-weight: 500;
							}
						}

						& p:last-child {
							margin-right: 0;
							// float: right;
						}

						.ttshop_myordercontitle_right {
							float: right;
							line-height: 32px;

							.ttshop_cancel {
								font-size: 12px;
								color: #999;
								// margin-bottom: 2px;
							}

							.ttshop_over {
								font-size: 12px;
								color: #ff0e25;
								// margin-bottom: 2px;
							}

							strong {
								font-size: 12px;
								color: #ff0e25;
								font-weight: 400;
								cursor: pointer;
							}
						}
					}

					.ttshop_myorderconlist {
						width: 100%;
						min-height: 112px;
						border-left: 1px solid #ebebeb;
						border-bottom: 1px solid #ebebeb;
						box-sizing: border-box;
						border-right: 0;
						border-top: 0;

						.ttshop_myorderconleft {
							float: left;
							width: 50%;
							min-height: 112px;
							padding: 16px 20px 16px 10px;
							box-sizing: border-box;

							.ttshop_orderimg {
								float: left;
								width: 80px;
								height: 80px;
								margin-right: 12px;

								img {
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}

							.ttshop_ordertext {
								float: left;
								width: 205px;

								h5 {
									font-size: 12px;
									color: #333333;
									font-weight: 500;
									line-height: 18px;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
									overflow: hidden;
									margin-bottom: 8px;
								}

								span {
									font-size: 12px;
									color: #999;
									margin-right: 5px;

									strong {
										font-weight: 400;
										font-size: 12px;
										color: #999;
									}
								}
							}
						}

						.ttshop_myorderdj {
							float: left;
							width: 11%;
							text-align: center;
							padding-top: 16px;
							min-height: 112px;
							box-sizing: border-box;

							p {
								font-size: 12px;
								color: #333;

								span {
									font-size: 12px;
									color: #333;
								}
							}
						}

						.ttshop_myorderdjer {
							border-right: 1px solid #ebebeb;
						}

						.ttshop_shr {
							float: left;
							width: 12%;
							text-align: center;
							padding-top: 16px;
							min-height: 112px;
							box-sizing: border-box;
							border-right: 1px solid #ebebeb;

							p {
								font-size: 12px;
								color: #333;
							}
						}

						.ttshop_zfzje {
							float: left;
							width: 16%;
							text-align: center;
							padding-top: 16px;
							min-height: 112px;
							box-sizing: border-box;
							border-right: 1px solid #ebebeb;

							p {
								font-size: 12px;
								color: #333;
								margin-bottom: 8px;

								span {
									font-size: 12px;
									color: #333;
								}
							}

							strong {
								font-size: 12px;
								color: #333;
								font-weight: 400;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									color: #ff0e25;
								}
							}
						}

						// .ttshop_qbzt {
						//   float: left;
						//   width: 15%;
						//   text-align: center;
						//   padding-top: 16px;
						//   min-height: 138px;
						//   box-sizing: border-box;
						//   border-right: 1px solid #ebebeb;
						//   .ttshop_wfk {
						//     font-size: 12px;
						//     color: #ff8500;
						//     margin-bottom: 2px;
						//   }
						//   .ttshop_cancel {
						//     font-size: 12px;
						//     color: #999;
						//     margin-bottom: 2px;
						//   }
						//   .ttshop_over {
						//     font-size: 12px;
						//     color: #333;
						//     margin-bottom: 2px;
						//   }
						//   strong {
						//     font-size: 12px;
						//     color: #ff0e25;
						//     font-weight: 400;
						//     cursor: pointer;
						//   }
						// }

						.ttshop_caozuo {
							float: left;
							width: 16%;
							text-align: center;
							padding-top: 16px;
							min-height: 112px;
							box-sizing: border-box;
							border-right: 1px solid #ebebeb;

							.ttshop_ljzf {
								display: block;
								width: 72px;
								height: 24px;
								border: 1px solid #ff3346;
								background: #fff0f1;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #ff0e25;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
							}

							.ttshop_cztext {
								font-size: 12px;
								color: #333;
								margin-bottom: 8px;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									color: #ff0e25;
								}
							}

							.ttshop_hg {
								display: block;
								width: 72px;
								height: 24px;
								background: #ebebeb;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #999;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;

								&:hover {
									background: #ff0e25;
									color: #fff;
								}
							}

							.ttshop_queren {
								display: block;
								width: 72px;
								height: 24px;
								background: #ff0e25;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
							}
						}
					}
				}

				.ttshop_caozuos {
					float: right;
					width: 24%;
					text-align: center;
					padding-top: 16px;
					min-height: 112px;
					box-sizing: border-box;
					border-right: 1px solid #ebebeb;
					border-bottom: 1px solid #ebebeb;

					.ttshop_cztexts {
						font-size: 12px;
						color: #ff0e25;
						margin-bottom: 8px;
					}

					.ttshop_ljzf {
						display: block;
						width: 72px;
						height: 24px;
						border: 1px solid #ff3346;
						background: #fff0f1;
						line-height: 24px;
						text-align: center;
						font-size: 12px;
						color: #ff0e25;
						margin: 0 auto 8px;
						border-radius: 2px;
						cursor: pointer;
					}

					.ttshop_cztext {
						font-size: 12px;
						color: #333;
						margin-bottom: 8px;
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							color: #ff0e25;
						}
					}

					.ttshop_hg {
						display: block;
						width: 72px;
						height: 24px;
						background: #ebebeb;
						line-height: 24px;
						text-align: center;
						font-size: 12px;
						color: #999;
						margin: 0 auto 8px;
						border-radius: 2px;
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							background: #ff0e25;
							color: #fff;
						}
					}

					.ttshop_queren {
						display: block;
						width: 72px;
						height: 24px;
						background: #ff0e25;
						line-height: 24px;
						text-align: center;
						font-size: 12px;
						color: #fff;
						margin: 0 auto 8px;
						border-radius: 2px;
						cursor: pointer;
					}
				}
			}

			.ttshop_myorderpage {
				width: 100%;
				margin-top: 32px;

				.ttshop_pages {
					float: right;
				}
			}
		}
	}

	.ttshop_pay {
		.pay-title {
			width: 100%;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.pay-qrcode {
			width: 200px;
			height: 200px;
		}
	}
</style>
